import React from 'react';
import { Grid } from '@met/react-components';

import azureAd from '../../config/azureAd';
import {
  Content,
  Footer,
  InnerContent,
  Main,
  RightContent,
  TopNav,
  Wrapper,
} from './styled';

const Layout = props => {
  return (
    <Wrapper>
      <Content>
        <TopNav
          leftNavItems={[
            { label: 'Dashboard', to: '/' },
            { label: 'Api Applications', to: '/apiApplications' },
          ]}
          rightNavItems={[
            { label: 'Sign Out', onClick: () => azureAd.logOut() },
          ]}
        />
        <Main>
          <RightContent>
            <InnerContent>
              <Grid style={{ height: '100%' }}>{props.children}</Grid>
            </InnerContent>
            <Footer>
              <span>© {new Date().getFullYear()} - Milwaukee Tool</span>
            </Footer>
          </RightContent>
        </Main>
      </Content>
    </Wrapper>
  );
};

export default Layout;
